import lscache from 'lscache'

import {
  ACCESS_TOKEN_EXPIRATION_TIME,
  GOOGLE_ACCESS_TOKEN_EXPIRATION_TIME,
  REFRESH_TOKEN_EXPIRATION_TIME,
} from '../constants'

const LS_KEY_USER = 'user'
const LS_KEY_ACCESS_TOKEN = 'accessToken'
const LS_KEY_REFRESH_TOKEN = 'refreshToken'
const LS_KEY_GOOGLE_ACCESS_TOKEN = 'googleAccessToken'

export const createSession = (
  user,
  accessToken,
  refreshToken,
  googleAccessToken,
) => {
  lscache.set(LS_KEY_USER, user, ACCESS_TOKEN_EXPIRATION_TIME)
  lscache.set(LS_KEY_ACCESS_TOKEN, accessToken, ACCESS_TOKEN_EXPIRATION_TIME)
  lscache.set(LS_KEY_REFRESH_TOKEN, refreshToken, REFRESH_TOKEN_EXPIRATION_TIME)

  if (googleAccessToken) {
    lscache.set(
      LS_KEY_GOOGLE_ACCESS_TOKEN,
      googleAccessToken,
      GOOGLE_ACCESS_TOKEN_EXPIRATION_TIME,
    )
  }
}

export const getAccessToken = () => lscache.get(LS_KEY_ACCESS_TOKEN)
export const getRefreshToken = () => lscache.get(LS_KEY_REFRESH_TOKEN)

export const getGoogleAccessToken = () =>
  lscache.get(LS_KEY_GOOGLE_ACCESS_TOKEN)

export const getUser = () => lscache.get(LS_KEY_USER)

export const destroySession = () => {
  lscache.flush()

  // lscache.flush() clears LS_KEY_USER and LS_KEY_ACCESS_TOKEN, but don't clear LS_KEY_REFRESH_TOKEN.
  // This occurs only when using /account/login-email (for /account/login is working correctly).
  lscache.remove(LS_KEY_REFRESH_TOKEN)
}
